// extracted by mini-css-extract-plugin
export default {"sortLink":"ColumnHeader_sortLink__WlrI8"};